/**
 * Created by PJPERF on 05.04.2017.
 */
import config from "../../config";
import React from "react";
import InputField from "../../components/subcomponents/controls/inputfield";
import Button from "../../components/subcomponents/controls/button";
import FormHeader from "../../components/subcomponents/formheader";
import { connect } from "react-redux";
import auth from "../../api/auth";
import notification from "../../components/subcomponents/notification";
import ReactTooltip from "react-tooltip";
import Notification from "../../components/notification";
import BusyScreen from "../../components/subcomponents/busy";

class LoginForm extends React.Component {
  handleSubmit(event) {
    let cur_obj = this;
    auth.login(function (error, response) {
      if (!error) {
        cur_obj.props.history.replace(config.default_page);
      } else {
        notification.error(error.api_error.message);
      }
    });
  }
  render() {
    let title = "RACE EVENTS & HISTORY";
    return (
      <div className="main_wrap">
        <ReactTooltip />
        <Notification />
        <div className="page_body_wrap">
          <div className="page_body">
            <div className="form_wrap login">
              <form
                onSubmit={this.handleSubmit.bind(this)}
                id="login"
                className="form login"
                method="POST"
                target="_self"
              >
                <FormHeader title={title} />
                <InputField
                  name="username"
                  tip="Enter username"
                  label="Username"
                  onChange={this.props.fieldUpdate}
                  value={this.props.username}
                  autofocus={true}
                  postfix="login"
                />
                <InputField
                  name="password"
                  tip="Enter password"
                  label="Password"
                  onChange={this.props.fieldUpdate}
                  value={this.props.password}
                  postfix="login"
                  type="password"
                />
                <Button
                  name="submit"
                  label="Login"
                  onClick={this.handleSubmit.bind(this)}
                  status={this.props.login_btn}
                  type="submit"
                />
                {/* <InputField name="hostname" label="Hostname" onChange={this.props.hostUpdate} value={this.props.hostname}/> */}
              </form>
            </div>
          </div>
        </div>
        <BusyScreen />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.authR.login.username,
    password: state.authR.login.password,
    hostname: state.systemR.connection.hostname,
    protocol: state.systemR.connection.protocol,
    login_btn:
      state.authR.login.username &&
      state.authR.login.password &&
      state.systemR.connection.hostname
        ? "enabled"
        : "disabled",
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fieldUpdate: function (result) {
      dispatch({
        type: "FIELD_UPDATE",
        field: result.name,
        value: result.value,
      });
    },
    hostUpdate: function (result) {
      dispatch({
        type: "HOSTNAME_UPDATE",
        hostname: result.value,
      });
    },
  };
}

export default LoginForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);
